import {Decoder, equal, oneOf} from 'json-bouncer'

export type M = 'Attachment' | 'ProofCopy' | 'Print'

export function decoder(): Decoder<M> {
    return oneOf([
        equal<M>('Attachment'),
        equal<M>('ProofCopy'),
        equal<M>('Print'),
    ])
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaFileType.ts